import * as React from 'react';

import { WBSelect, WBText } from '@/core';
import { generateTimeIntervals } from './utils';
import styles from './style';
import { InnerComponentProps } from './model';

export const SelectTimeSlot: React.FC<InnerComponentProps> = (props) => {
	const {
		endTimeValue,
		endVisible,
		icon,
		isDisabled,
		label,
		minuteInterval,
		onCancel,
		onConfirm,
		onTimeSlotSelect,
		placeholder,
		placeholder2,
		startTimeValue,
		startVisible,
		timeSlot,
		timeSlots,
		toggleTimeSelect,
		value,
		value2Prefix,
		valuePrefix,
	} = props;
	const items = React.useMemo(
		() =>
			generateTimeIntervals(minuteInterval).map((time) => ({
				label: time,
				value: time,
			})),
		[],
	);

	return (
		<>
			<WBSelect
				icon={icon}
				isDisabled={isDisabled}
				items={items}
				label={label}
				onChange={(value) => onConfirm('start', value as string)}
				placeholder={placeholder}
				value={startTimeValue}
			>
				<WBText style={styles.label}>{valuePrefix}</WBText>
			</WBSelect>

			<WBSelect
				icon={null}
				isDisabled={isDisabled}
				items={items}
				onChange={(value) => onConfirm('end', value as string)}
				placeholder={placeholder2}
				showBorder={true}
				value={endTimeValue}
			>
				<WBText style={styles.label}>{value2Prefix}</WBText>
			</WBSelect>
		</>
	);
};
